import Vue from 'vue';
import { cloneDeep } from 'lodash';

// No.8 Phase 4：申請者・代行者 問合せ 一覧の検索・ページング・ソート状態
// 管理者側（cms/inquiries/search.js）と同じ形にする。条件は今のところステータス1つだが、
// filter オブジェクトのままにして、条件が増えたときに同じ書き方で足せるようにする。
// ※ 申請者ページと代行者ページは同一コンポーネントのため状態を共有する（分岐なし）。
const INIT_DATA = {
  currentPage: 1,
  perPage: 10,
  filter: {
    // null=未選択（すべて）
    status: null,
  },
  // 既定：最終更新日時の降順（直近が上）
  sortBy: 'updated_at',
  sortDesc: true,
};

export default {
  namespaced: true,
  state: cloneDeep(INIT_DATA),
  mutations: {
    setFilter(state, param) {
      Vue.set(state.filter, param.key, param.value);
      // 絞り込み条件が変わったら1ページ目に戻す（空ページ表示の回避）
      state.currentPage = 1;
    },
    setCurrentPage(state, page) {
      state.currentPage = page;
    },
    setPerPage(state, num) {
      state.perPage = num;
      state.currentPage = 1;
    },
    setSortBy(state, v) {
      state.sortBy = v;
    },
    setSortDesc(state, v) {
      state.sortDesc = v;
    },
    initFilter(state) {
      Vue.set(state, 'filter', cloneDeep(INIT_DATA.filter));
      state.currentPage = INIT_DATA.currentPage;
      state.perPage = INIT_DATA.perPage;
      state.sortBy = INIT_DATA.sortBy;
      state.sortDesc = INIT_DATA.sortDesc;
    },
  },
  actions: {
  },
};
